import PillLoadingBox from 'LuxKit/PillLoadingBox'
import ModalContext from 'contexts/ModalContext'
import React, { MouseEventHandler, useCallback, useContext } from 'react'
import BusinessTravellerHotelCreditsOverBudgetInfoModal from './BusinessTravellerOfferHotelCreditsOverBudgetInfoModal'
import useBusinessTravellerOfferCreditFetcher from 'businessTraveller/hooks/useBusinessTravellerOfferCreditFetcher'
import PriceRowBusinessTravellerCredit from 'LuxKit/PricePoints/BusinessTraveller/PriceRowBusinessTravellerCredit'
import PriceRowBusinessTravellerExceededBudget from 'LuxKit/PricePoints/BusinessTraveller/PriceRowBusinessTravellerExceededBudget'
import BusinessTravellerOfferCreditsInfoModal from './BusinessTravellerOfferCreditsInfoModal'
import PriceRowBusinessTravellerUnderBudget from 'LuxKit/PricePoints/BusinessTraveller/PriceRowBusinessTravellerUnderBudget'
import BusinessTravellerOfferCreditsUnderBudgetInfoModal from './BusinessTravellerOfferCreditsUnderBudgetInfoModal'

type SupportedOffer =
  App.Offer |
  App.OfferSummary |
  App.BedbankOffer |
  App.BedbankOfferSummary

type Props = {
  numberOfNights?: number
  offer: SupportedOffer
  totalCost: number
  type: 'exact' | 'estimate'
  roomCount?: number
}

function BusinessTravellerOfferCreditsTextLink(props: Props) {
  const {
    offer,
    totalCost,
    numberOfNights = 1,
    type,
    roomCount,
  } = props
  const showModal = useContext(ModalContext)

  const { offerCreditData } = useBusinessTravellerOfferCreditFetcher({ offer, numberOfNights, cost: totalCost, roomCount })

  const showCreditInfoModal = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()

    showModal(<BusinessTravellerOfferCreditsInfoModal />)
  }, [showModal])

  const showOverBudgetInfoModal = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()

    showModal(<BusinessTravellerHotelCreditsOverBudgetInfoModal numberOfNights={numberOfNights} />)
  }, [numberOfNights, showModal])

  const showUnderBudgetInfoModal = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()

    showModal(<BusinessTravellerOfferCreditsUnderBudgetInfoModal />)
  }, [showModal])

  const showUnderBudgetInfo = offerCreditData?.status === 'success' && offerCreditData?.budgetCompliance === 'under_budget'
  const showOverBudgetInfo = offerCreditData?.status === 'success' && offerCreditData?.budgetCompliance === 'over_budget'

  return <>
    {(!offerCreditData || offerCreditData.status === 'pending') && <PillLoadingBox width={160}>Loading</PillLoadingBox>}

    {showUnderBudgetInfo && offerCreditData?.creditValue > 0 && <PriceRowBusinessTravellerCredit
      size="M"
      type={type}
      creditValue={offerCreditData.creditValue}
      onClick={showCreditInfoModal}
    />}

    {showUnderBudgetInfo && offerCreditData?.creditValue === 0 && <PriceRowBusinessTravellerUnderBudget
      underPercentage={offerCreditData.budgetComparison}
      onClick={showUnderBudgetInfoModal}
    />}

    {showOverBudgetInfo && <PriceRowBusinessTravellerExceededBudget
      exceedingPercentage={offerCreditData.budgetComparison}
      onClick={showOverBudgetInfoModal}
    />}
  </>
}

export default BusinessTravellerOfferCreditsTextLink
